import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import constants from '../../config/constants'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import PassengerSSRInterface from '../../interfaces/client/PassengerSSR'
import ClientNotificationInterface from '../../interfaces/client/Notification'
import PassengerSSRWithSSROriginalSSRInterface from '../../interfaces/client/PassengerSSRWithSSROriginalSSR'

import {
  removePassengerSSR,
  setPassengerSSRToDelete,
  unsetPassengerSSRToDelete,
} from '../../actions/passengers'
import { removeNotification } from '../../actions/notifications'

import {
  getWarningNotifications,
  getNotificationLabelFromCode,
} from '../../utils/notifications'

import PassengerSSRs from '../../components/PassengerSSRs'

interface PassengerSSRsPropsInterface {
  passengerId: string
  isDisabled: boolean
  readonly: boolean
  startOnColumnThree?: boolean
}

const isSSRNotification = ({ fieldName = '' }: ClientNotificationInterface) =>
  constants.SSRIds.includes(fieldName)

export const mapStateToProps = (
  state: ReduxStoreInterface,
  {
    passengerId,
    isDisabled,
    readonly,
    startOnColumnThree = false,
  }: PassengerSSRsPropsInterface
) => {
  const passengerHasSSRs = state.passengerSSRs.allIds.includes(passengerId)

  const passengerSSRs: PassengerSSRInterface[] = passengerHasSSRs
    ? state.passengerSSRs.byId[passengerId]
    : []

  const formattedPassengerSSRs: PassengerSSRWithSSROriginalSSRInterface[] = passengerSSRs.map(
    (passengerSSR: PassengerSSRInterface) => ({
      ...passengerSSR,
      ssr: state.ssrs.byId[passengerSSR.ssrId] || {},
    })
  )

  const passengerNotifications =
    state.notifications.passengerIdsToNotificationIds[passengerId]
  const hasNotifications = Boolean(passengerNotifications)

  const getNotification = (notificationKey: string) =>
    state.notifications.byId[notificationKey]
  const errors = hasNotifications
    ? getWarningNotifications(passengerNotifications.map(getNotification))
    : []

  const errorMessages = errors
    .filter(isSSRNotification)
    .map(getNotificationLabelFromCode)
  const errorIds = errors
    .filter(isSSRNotification)
    .map((notification: ClientNotificationInterface) => notification.id)

  return {
    startOnColumnThree,
    passengerId,
    passengerSSRs: formattedPassengerSSRs,
    isDisabled,
    readonly,
    errorMessages,
    errorIds,
    hasError: Boolean(errorMessages.length),
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  removeSSR: (passengerId: string, passengerSSRId: string) => {
    dispatch(removePassengerSSR(passengerId, passengerSSRId))
  },
  setPassengerSSRToDelete: (passengerId: string, passengerSSRId: string) => {
    dispatch(setPassengerSSRToDelete(passengerId, passengerSSRId))
  },
  unsetPassengerSSRToDelete: (passengerId: string, passengerSSRId: string) => {
    dispatch(unsetPassengerSSRToDelete(passengerId, passengerSSRId))
  },
  removeNotification: (notificationId: string) => {
    dispatch(removeNotification(notificationId))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PassengerSSRs)
